export const MARGINS = ["Top", "Right", "Bottom", "Left"];

export { Margin } from "./Margin";
export { Padding } from "./Padding";
